import React from "react";
import { Card, CardTitle, CardBody, Typography, Link } from "@one-thd/sui-atomic-components";

const ConfiguredCardTitle = ({ cardTitleConfig }) => {

  const { header, action, ...titleProps } = cardTitleConfig;

  let headerElement = null;
  if (header) {
    const { variant, weight, className, text, ...restHeaderProps } = header;
    headerElement = (
      <Typography
        variant={variant || "h3"}
        weight={weight || "regular"}
        className={className}
        {...restHeaderProps}
      >
        {text}
      </Typography>
    );
  }

  let actionElement = null;
  if (action) {
    actionElement = (
      <Link href={action.href} className={action.className}>
        {action.text}
      </Link>
    );
  }

  return (
    <CardTitle
      header={headerElement}
      action={actionElement}
      {...titleProps}
    />
  );
};

export const withCard = (WrappedComponent, options) => {
  const CardWrapper = (props) => {
    const { card = {}, cardBody: cardBodyProps, cardTitle } = options || {};

    const cardProps = {
      className: "sui-h-full",
      ...card,
    };

    return (
      <Card {...cardProps}>
        {cardTitle && <ConfiguredCardTitle cardTitleConfig={cardTitle} />}
        <CardBody {...cardBodyProps}>
          <WrappedComponent {...props} />
        </CardBody>
      </Card>
    );
  };
  CardWrapper.dataModel = WrappedComponent.dataModel || {};
  CardWrapper.wraps = { ...(WrappedComponent.wraps || {}), card: true };
  CardWrapper.$$typeof = WrappedComponent.$$typeof;
  CardWrapper.displayName = WrappedComponent.displayName;

  return CardWrapper;
};